<script setup lang="ts">
import { UiButton, UiModal } from "@packages/component-library";
import { onBeforeMount, onMounted, ref } from "vue";
import APIPassport from "@/package/config/passport-api";
import { useI18n } from "vue-i18n";

const emit = defineEmits(["close"]);
const { t } = useI18n();
const buttonLoader = ref(false);
const showModal = ref(false);

const confirmMarketingNotification = () => {
  if (!buttonLoader.value) {
    buttonLoader.value = true;

    try {
      APIPassport.post("api/v3/hub/person", { marketing_enabled: true }).then(
        () => {
          emit("close");
        }
      );
    } catch (e) {
      console.log(e);
    } finally {
      buttonLoader.value = false;
    }
  }
};

onBeforeMount(() => {
  APIPassport.post("api/v3/hub/person/marketing-shown");
});

onMounted(() => {
  showModal.value = true;
});
</script>

<template>
  <UiModal
    v-model="showModal"
    hide-header
    size="s"
    @update:modelValue="emit('close')"
  >
    <template #default>
      <div class="marketing-notification">
        <img src="@/assets/images/marketing-info.svg" alt="" />
        <h5>{{ t("marketingModal.title") }}</h5>
        <p>
          {{ t("marketingModal.description") }}
        </p>
      </div>
    </template>

    <template #footer>
      <div class="marketing-notification__actions">
        <UiButton
          :label="t('marketingModal.confirmAction')"
          size="m"
          :disabled="buttonLoader"
          :loading="buttonLoader"
          @click="confirmMarketingNotification"
        />
        <UiButton
          :label="t('marketingModal.notNowAction')"
          color="secondary"
          size="m"
          @click="emit('close')"
        />
      </div>
    </template>
  </UiModal>
</template>

<style scoped lang="scss">
.marketing-notification {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  > h5 {
    @include h4();
    text-align: center;
    color: var(--color-semantic-content-normal-primary);
    margin: calc($base-space * 4) 0 0;
  }

  > p {
    margin: calc($base-space * 2) 0 0;
    @include body-m();
    color: var(--color-semantic-content-normal-primary);
    text-align: center;
    padding: 0 calc($base-space * 4);
  }

  &__actions {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    gap: calc($base-space * 2);
    width: 100%;
    > button {
      width: 100%;
    }
  }
}
</style>
